// extracted by mini-css-extract-plugin
export default {"overlay":"Dropdown_overlay__o7X2b","dropdown":"Dropdown_dropdown__+CYtR alude-dropdown","iconArea":"Dropdown_iconArea__E4Egv"};